import { CANONICAL_USER_ID_REGEX } from "../utils/profileRoutes";

export const requireCanonicalUserId = (userId) => {
    const trimmedUserId = typeof userId === "string" ? userId.trim() : "";
    if (!CANONICAL_USER_ID_REGEX.test(trimmedUserId)) {
        throw new Error("userId must be a canonical UUIDv4");
    }
    return trimmedUserId;
};
